module.exports = __webpack_public_path__ + "static/media/Recording.ff42d57b.svg";